// src/utils/stringUtils.js
export function getArtigoCorreto(palavra) {
  if (!palavra) return 'o'; // padrão

  const primeiraLetra = palavra.trim()[0].toLowerCase();

  // Lista de palavras femininas conhecidas (ou terminações comuns)
  const femininas = ['a', 'e']; // pode ser mais sofisticado

  // Heurística simples: se terminar com "a", tende a ser feminino
  if (palavra.trim().toLowerCase().endsWith('a')) {
    return 'a';
  }

  return 'o';
}

export function normalizeNullableText(value) {
  if (value === null || value === undefined || value === 'null') {
    return '';
  }

  return value.trim();
}

export function normalizeNullableInputValue(value) {
  if (value === null || value === undefined || value === 'null') {
    return '';
  }

  return String(value);
}
